import ReceiptFromProductionCase from '@/models/ReceiptFromProduction/ReceiptFromProductionCase';

export default class ReceiptFromProductionCaseFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.receiptFromProductionId  = '';
		this.receiptFromProductionWorkOrderProcessDetail = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.qtyMaterial = '';
		this.qtyCase = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			receiptFromProductionId : '0',
			receiptFromProductionWorkOrderProcessDetail : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			partId : '0',
			partPartNumber : '0',
			qtyMaterial : '0',
			qtyCase : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}